import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    environment: import.meta.env.VITE_ENVIRONMENT,
    release: `eh-office-app@${import.meta.env.VITE_VERSION}`,
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            // eslint-disable-next-line no-restricted-syntax
            useEffect: React.useEffect,
            useLocation: useLocation,
            useNavigationType: useNavigationType,
            createRoutesFromChildren: createRoutesFromChildren,
            matchRoutes: matchRoutes,
        }),
    ],
    tracesSampleRate: 1,
    // tracePropagationTargets: ['localhost', /^https:\/\/([a-z0-9-]+\.)*eterno-health\.io(\/|$)/i], // can only be activated when headers are allowed in api
});
